import { GpsEventType } from 'app/constants/gpsEventType'

export const getGpsEventType = (type) => {
  let eventType = GpsEventType.NONE

  switch (type) {
    case 1:
      eventType = GpsEventType.DRIVER_IN_COUNTRY
      break
    case 2:
      eventType = GpsEventType.VEHICLE_IN_COUNTRY
      break
    case 3:
      eventType = GpsEventType.DRIVER_CROSSING_BORDER
      break
    case 4:
      eventType = GpsEventType.VEHICLE_CROSSING_BORDER
      break
    case 5:
      eventType = GpsEventType.DRIVER_IN_COUNTRY_PROGRESS
      break
    case 6:
      eventType = GpsEventType.VEHICLE_IN_COUNTRY_PROGRESS
      break
  }

  return eventType
}
